import {
	Col,
	Container,
	Form,
	FormGroup,
	OverlayTrigger,
	Row,
	Spinner,
	Tooltip,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import {
	CardMaterialTitle,
	ContentBody,
	ContentHeader,
	PrimaryButton,
	SecondaryButton,
} from "../../styled";
import { useEffect, useState } from "react";
import { DetailsForm } from "../components/details-form";
import { MenuForm } from "../components/menu-form";
import { PickListForm } from "../components/picklist-form";
import { BibliographyForm } from "../components/bibliography-form";
import {
	detailDisciplineManager,
	editMaterial,
	setItemsToDisciplinaManager,
} from "../../../../services/discipline.service";
import { IMaterial } from "../../../../models/IMaterial";
import {
	detailItemManager,
	setMediasToItemManager,
} from "../../../../services/item.service";
import {
	completeMediaUpload,
	detailMediaManager,
	s3UploadFile,
	unzipMedia,
	uploadMediaFile,
	zipStatusMedia,
} from "../../../../services/media.service";
import { FileUploadForm } from "../components/file-upload-form";
import { ObjectCategoryForm } from "../components/object-category-form";

import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Error from "../../../../components/Error";
import { toast } from "react-toastify";
import { ItemPickListForm } from "../components/item-picklist-form";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import handleLongText from "../../../../utils/handleLongText/handleLongText";
import { Modal } from "../../../../components/modal";

interface CaseType {
	[key: string]: string | undefined;
}

export const ProductDetails = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [loadingModal, setLoadingModal] = useState(false);
	const [loadingPage, setLoadingPage] = useState(false);
	const [showFreeModal, setShowFreeModal] = useState(false);

	const { topicId, id } = useParams<{ topicId: string; id: string }>();
	const [material, setMaterial] = useState<IMaterial>();

	const [isEdit, setIsEdit] = useState(false);

	const [removedMedia, setRemovedMedia] = useState(false);
	const [addedMediaFile, setAddedMediaFile] = useState(false);
	const [materialPrice, setMaterialPrice] = useState<number>(0);
	const [mediaFileAdd, setMediaFileAdd] = useState<any>();
	const [executablePath, setExecutablePath] = useState<string>();
	const [isGeneratingScorm, setIsGeneratingScorm] = useState<boolean>(true);
	const [zipTaskId, setZipTaskId] = useState<number>();
	const [formDataEdit, setFormDataEdit] = useState<any>();

	const getStatusZip = async () => {
		if (zipTaskId) {
			const res = await zipStatusMedia(zipTaskId);
			if (res === 100) {
				setIsGeneratingScorm(false);
			} else {
				setIsGeneratingScorm(true);
			}
		} else {
			setIsGeneratingScorm(false);
		}
	};

	const validationSchema = Yup.object({
		title: Yup.string().trim().required("Este campo é obrigatório"),
		description: Yup.string().nullable(),
		code: Yup.string().trim().required("Este campo é obrigatório"),
		price: Yup.number().nullable(),
		is_base_price: Yup.boolean(),
		deadline: Yup.number().required("Este campo é obrigatório"),
		workload:
			material?.type_product && material?.type_product === "Discipline"
				? Yup.string().trim().required("Este campo é obrigatório")
				: Yup.string(),
		// knowledge_area: Yup.array().min(1, "Este campo é obrigatório").required("Este campo é obrigatório"),
		// course: Yup.array(),
		reference: Yup.string().nullable(),
		discipline: Yup.string(),
		item: Yup.string(),
		discipline_items: Yup.array(),
		item_medias: Yup.array(),
		delivery_values: Yup.array(),
		// array de nível de formação - grad, pos, tecnico
		modalities: Yup.array(),
	});

	const {
		register,
		control,
		handleSubmit,
		setValue,
		formState: { errors },
	} = useForm({ resolver: yupResolver(validationSchema) });

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	useEffect(() => {
		getStatusZip();
	}, [zipTaskId]);

	useEffect(() => {
		getStatusZip();
		setLoadingPage(true);
		getMaterial(topicId, id);
	}, [topicId, id]);

	const getMaterial = (topicId: any, id: any) => {
		if (topicId && id) {
			if (topicId === "discipline") {
				detailDisciplineManager(id)
					.then((resp) => {
						setMaterial(resp);
						setLoadingPage(false);
					})
					.catch((err) => {
						toast.error(err.response.data.detail);
					});
			} else if (topicId === "item") {
				detailItemManager(id)
					.then((resp) => {
						setMaterial(resp);
						setLoadingPage(false);
					})
					.catch((err) => {
						toast.error(err.response.data.detail);
					});
			} else if (topicId === "media") {
				detailMediaManager(id)
					.then((resp) => {
						setMaterial(resp);
						setLoadingPage(false);
					})
					.catch((err) => {
						toast.error(err.response.data.detail);
					});
			}
		}
	};

	const handleEdit = () => {
		setIsEdit(true);
	};

	const handleCancelEdit = () => {
		setIsEdit(false);
	};

	const onSubmit = (formData: any) => {
		if (formData.price === 0) {
			setShowFreeModal(true);
			setFormDataEdit(formData);
		} else {
			handleSubmitFreeMaterial(formData);
		}
	};

	const handleSuccesMessage = () => {
		getMaterial(topicId, id);
		toast.success("Material editado com sucesso!", {
			position: toast.POSITION.BOTTOM_CENTER,
			pauseOnFocusLoss: false,
			hideProgressBar: true,
			pauseOnHover: false,
		});
		setIsEdit(false);
		setLoading(false);
	};

	const handleChainItems = (_material: any, formData: any) => {
		let itemList: any = {};
		if (_material.type_product === "Discipline") {
			let lista: any[] = [];
			formData.discipline_items.map((item: any) => {
				lista.push(item.id);
			});

			itemList = {
				discipline: _material.id,
				items: lista,
			};
		} else if (
			_material.type_product === "Item" ||
			_material.type_product === "Theme"
		) {
			let lista: any[] = [];
			formData.item_medias.map((item: any) => {
				lista.push(item.id);
			});

			itemList = {
				item: _material.id,
				medias: lista,
			};
		}
		return itemList;
	};

	const handleNameDetails = (_topicId: string): string => {
		const cases: CaseType = {
			discipline: translation("manager.type.discipline"),
			item: translation("manager.type.unity"),
			theme: translation("manager.type.theme"),
			media: translation("manager.type.object"),
		};

		return cases[_topicId] || "Não informado";
	};

	const handleSubmitFreeMaterial = (formData?: any) => {
		if (formDataEdit) {
			formData = formDataEdit;
		}

		if (formData.item === undefined) {
			formData.item = null;
		}

		if (formData.discipline === undefined) {
			formData.discipline = null;
		}

		setLoading(true);
		setLoadingModal(true);
		let itemList: any = {};

		if (isEdit && material?.id && material.type_product) {
			itemList = handleChainItems(material, formData);
			if (!formData.item) {
				formData.item = null;
			}
			if (!formData.discipline) {
				formData.discipline = null;
			}

			if (
				(!mediaFileAdd || !mediaFileAdd?.path) &&
				material.type_product === "Media"
			) {
				formData.url_path = "no_media";
			}

			if (materialPrice) {
				formData.price = materialPrice;
			}

			editMaterial(material.id, material.type_product, formData)
				.then((data) => {
					if (material.type_product === "Discipline") {
						setItemsToDisciplinaManager(itemList).then((_data) => {
							handleSuccesMessage();
							setShowFreeModal(false);
							setMaterial(_data);
						});
					} else if (
						material.type_product === "Item" ||
						material.type_product === "Theme"
					) {
						setMediasToItemManager(itemList).then((_data) => {
							handleSuccesMessage();
							setShowFreeModal(false);
							setMaterial(_data);
						});
					} else if (
						material.type_product === "Media" &&
						addedMediaFile
					) {
						let form = {
							name: mediaFileAdd.name,
							format: mediaFileAdd?.type,
							preview_file_index: executablePath,
						};

						// Requesting s3 signed url
						uploadMediaFile(data.id, form)
							.then((res) => {
								// Uploading file to s3
								s3UploadFile(
									res.tmp_url,
									mediaFileAdd,
									res.format
								).then((res) => {
									// WaterMark and upload_complete
									completeMediaUpload(data.id).then(() => {
										// Case scorm, unzip media file
										if (executablePath) {
											unzipMedia(data.id).then((res) => {
												handleSuccesMessage();
												setAddedMediaFile(false);
												setMediaFileAdd(null);
												setZipTaskId(res.ziptask);
											});
										} else {
											handleSuccesMessage();
											setShowFreeModal(false);
											setAddedMediaFile(false);
											setMediaFileAdd(null);
										}
									});
								});
							})
							.catch((err) => {
								toast.error(
									"Ocorreu um erro ao editar o material."
								);
								setLoading(false);
								setLoadingModal(false);
							});
					} else {
						handleSuccesMessage();
						setShowFreeModal(false);
						setLoadingModal(false);
						setMaterial(data);
					}
				})
				.catch((err) => {
					toast.error("Ocorreu um erro ao salvar o material.", {
						position: toast.POSITION.BOTTOM_CENTER,
						pauseOnFocusLoss: false,
						hideProgressBar: true,
						pauseOnHover: false,
					});
					setLoading(false);
					setLoadingModal(false);
				});
		}
	};

	return (
		<Container fluid>
			{loadingPage ? (
				<>
					<div className="loading-container mt-5">
						<Spinner
							animation="border"
							variant="primary"
							style={{
								width: "2rem",
								height: "2rem",
								borderWidth: "0.25em",
								borderRightColor: "transparent",
							}}
						/>
					</div>
				</>
			) : (
				<>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ContentHeader>
							<Row>
								<Col>
									<span className="title">
										<OverlayTrigger
											placement="top"
											overlay={
												<Tooltip>
													{translation("back")}
												</Tooltip>
											}
										>
											<span>
												<HiOutlineArrowCircleLeft
													className="mr-1 mb-1 cursor-pointer"
													onClick={() =>
														history.goBack()
													}
												/>
											</span>
										</OverlayTrigger>
										{translation("manager.links.toView") +
											" " +
											handleNameDetails(topicId)}
									</span>
								</Col>
								<Col
									md={4}
									lg={3}
									xxl={2}
									className="text-end"
								>
									{!isEdit ? (
										<PrimaryButton
											style={{
												width: "70%",
												float: "right",
											}}
										>
											<button
												name="addbutton"
												type="button"
												onClick={handleEdit}
											>
												Editar
											</button>
										</PrimaryButton>
									) : (
										<>
											{loading ? (
												<Spinner
													animation="border"
													variant="primary"
													style={{
														width: "2rem",
														height: "2rem",
														borderWidth: "0.25em",
														borderRightColor:
															"transparent",
													}}
												/>
											) : (
												<Row>
													<Col
														sm={6}
														className="pl-0"
													>
														<SecondaryButton
															style={{
																width: "100%",
																float: "right",
															}}
														>
															<button
																name="addbutton"
																type="button"
																onClick={
																	handleCancelEdit
																}
															>
																Cancelar
															</button>
														</SecondaryButton>
													</Col>
													<Col
														sm={6}
														className="pl-0"
													>
														<PrimaryButton
															style={{
																width: "100%",
																float: "right",
															}}
														>
															<button
																name="addbutton"
																type="submit"
															>
																Salvar
															</button>
														</PrimaryButton>
													</Col>
												</Row>
											)}
										</>
									)}
								</Col>
							</Row>
						</ContentHeader>
						<ContentBody>
							<Row className="mt-3">
								<Col>
									<CardMaterialTitle
										className={`material-${topicId}`}
									>
										<Col md={6}>
											{!isEdit ? (
												<>
													{material &&
													material.title.length >
														100 ? (
														<OverlayTrigger
															placement={"top"}
															overlay={
																<Tooltip
																	id={`tooltip-materials`}
																>
																	{
																		material?.title
																	}
																</Tooltip>
															}
														>
															<span
																style={{
																	fontSize:
																		"16px",
																}}
															>
																{handleLongText(
																	material?.title,
																	100
																)}
															</span>
														</OverlayTrigger>
													) : (
														<div>
															<span
																style={{
																	fontSize:
																		"16px",
																}}
															>
																{
																	material?.title
																}
															</span>
														</div>
													)}
												</>
											) : (
												<FormGroup>
													<Form.Control
														id="title"
														type="text"
														defaultValue={
															material?.title
														}
														{...register("title", {
															required: true,
														})}
													></Form.Control>
													{errors.title ? (
														<div className="w-100">
															{" "}
															<Error>
																{
																	errors.title
																		?.message
																}
															</Error>{" "}
														</div>
													) : (
														""
													)}
												</FormGroup>
											)}
										</Col>
									</CardMaterialTitle>
								</Col>
							</Row>
							<Row className="mt-3">
								<Col md={12}>
									<DetailsForm
										key={material?.id}
										updateData={isEdit}
										itemData={material}
										type={material?.type_product}
										formRegister={register}
										control={control}
										formErrors={errors}
										handleSetValue={setValue}
									></DetailsForm>
								</Col>
							</Row>
							{material?.type_product != "Object" &&
							material?.type_product != "Media" ? (
								<>
									<Row className="mt-3">
										<Col>
											<MenuForm
												updateData={isEdit}
												itemData={material}
												formRegister={register}
												formErrors={errors}
												handleSetValue={setValue}
											></MenuForm>
										</Col>
									</Row>
									<Row className="mt-3">
										<Col>
											{material?.type_product ===
											"Discipline" ? (
												<>
													<PickListForm
														updateData={isEdit}
														itemData={material}
														handleSetValue={
															setValue
														}
													></PickListForm>
												</>
											) : (
												<></>
											)}

											{material?.type_product ===
												"Item" ||
											material?.type_product ===
												"Theme" ? (
												<>
													<ItemPickListForm
														updateData={isEdit}
														itemData={material}
														handleSetValue={
															setValue
														}
													></ItemPickListForm>
												</>
											) : (
												<></>
											)}
										</Col>
									</Row>
									<Row className="mt-3">
										<Col>
											<BibliographyForm
												updateData={isEdit}
												itemData={material}
												handleSetValue={setValue}
											></BibliographyForm>
										</Col>
									</Row>
								</>
							) : (
								<>
									<Row className="mt-3">
										<Col>
											<FileUploadForm
												isGeneratingScorm={
													isGeneratingScorm
												}
												executablePath={
													setExecutablePath
												}
												updateData={isEdit}
												itemData={material}
												onAdd={setMediaFileAdd}
												isAdded={setAddedMediaFile}
											></FileUploadForm>
										</Col>
										<Col md={4}>
											<ObjectCategoryForm
												setPrice={setMaterialPrice}
												updateData={isEdit}
												itemData={material}
												handleSetValue={setValue}
												control={control}
											></ObjectCategoryForm>
										</Col>
									</Row>
								</>
							)}
						</ContentBody>
					</Form>
				</>
			)}

			<Modal
				headerTitle="Aviso"
				submitButtonText={translation("continue")}
				show={showFreeModal}
				onHide={() => setShowFreeModal(false)}
				onSubmit={handleSubmitFreeMaterial}
				variant="confirm-modal-default"
				loading={loadingModal}
			>
				<p className="font-16">
					Você inseriu um valor de <b>R$ 0,00</b>. Este material
					aparecerá como <b>GRATUITO</b> na loja.
				</p>
				<p className="font-14">
					Tem certeza que deseja continuar mesmo assim?
				</p>
			</Modal>
		</Container>
	);
};
